import { ExternalLink, Trash2 } from 'lucide-react';

import { RowActionsMenu } from '~/components/ui';
import { routes } from '~/app/routes';
import type { MlsRow } from '~/components/Constants/mlsConstants';
import { feedId } from '~/components/pages/mls/components/feedActions';

interface MlsQuickActionsProps {
  rowData: MlsRow;
  onDelete: (row: MlsRow) => void;
}

/** Open the record page, or delete from here. Every other feed action lives on the record page. */
export default function MlsQuickActions({ rowData, onDelete }: MlsQuickActionsProps) {
  return (
    <RowActionsMenu
      testId={`feeds-table-actions-${rowData._id}`}
      items={[
        {
          label: 'Open feed',
          icon: <ExternalLink className="size-4" aria-hidden="true" />,
          href: routes.feed(feedId(rowData)),
          testId: 'openFeed',
        },
        {
          label: 'Delete feed',
          icon: <Trash2 className="size-4" aria-hidden="true" />,
          testId: 'deleteFeed',
          destructive: true,
          onClick: () => onDelete(rowData),
        },
      ]}
    />
  );
}
